// Maps raw LOB device type to a category key matching legacy Device.getDeviceType
const getDeviceType = (deviceType) => {
  switch (deviceType) {
    case 'video': return 'tv';
    case 'internet':
    case 'storeFront':
    case 'voice': return 'internetVoice';
    case 'home': return 'home';
    default: return null;
  }
};

// Maps category key + flexFlag to group title/description matching legacy Device.addFriendlyNames
const addFriendlyNames = (deviceType, flexFlag) => {
  const key = getDeviceType(deviceType);
  const effectiveKey = flexFlag && key === 'internetVoice' ? 'internetVoiceStreaming' : key;

  switch (effectiveKey) {
    case 'tv':
      return { groupTitle: 'TV', groupDescription: 'Your set-top boxes and remote controls' };
    case 'internetVoice':
      return { groupTitle: 'Internet & Voice', groupDescription: 'Your modems and WiFi routers' };
    case 'internetVoiceStreaming':
      return {
        groupTitle: 'Internet & Voice',
        groupDescription: 'Your modems, WiFi routers, and streaming devices',
      };
    case 'home':
      return { groupTitle: 'Home', groupDescription: 'Your Xfinity home controlling units' };
    default:
      return { groupTitle: null, groupDescription: null };
  }
};

const addDeviceCardTitle = (device, deviceType) => {
  let title = device.title || device.friendlyName || `${deviceType} Device`;
  if (deviceType === 'video') title = `${device.x1 ? 'X1 ' : ''}TV Box`;
  if (deviceType === 'storeFront') title = 'Streaming TV Box';
  if (deviceType === 'internet' && device.gatewayType === 'ADVANCED_MODEM') {
    title = 'Advanced Modem';
  }
  return { ...device, title };
};

// Builds byService from the merged device data returned by the devices action
export const buildByService = (services = {}) => {
  const flexFlag = !!services.storeFront;
  const deviceList = [];

  Object.entries(services).forEach(([lob, devices]) => {
    if (!Array.isArray(devices)) return;
    devices.forEach((device) => {
      deviceList.push(addDeviceCardTitle({ ...device, deviceType: lob }, lob));
    });
  });

  const groups = deviceList.reduce((acc, device) => {
    const { groupTitle, groupDescription } = addFriendlyNames(device.deviceType, flexFlag);
    if (!groupTitle) return acc;

    const existing = acc.find(g => g.title === groupTitle);
    if (existing) {
      if (!existing.devices.some(d => d.serialNumber === device.serialNumber)) {
        existing.devices.push(device);
      }
    } else {
      acc.push({
        title: groupTitle,
        description: groupDescription,
        type: device.deviceType,
        devices: [device],
      });
    }
    return acc;
  }, []);

  return groups;
};

// Builds byService array from account.devices.list (flat array with lob property)
export const buildByServiceFromAccount = (deviceList = []) => {
  const flexFlag = deviceList.some(d => d.lob === 'storeFront');

  return deviceList.reduce((acc, device) => {
    const { groupTitle, groupDescription } = addFriendlyNames(device.lob, flexFlag);
    if (!groupTitle) return acc;
    const cardDevice = addDeviceCardTitle({ ...device, deviceType: device.lob }, device.lob);

    const existing = acc.find(g => g.title === groupTitle);
    if (existing) {
      if (!existing.devices.some(d => d.serialNumber === cardDevice.serialNumber)) {
        existing.devices.push(cardDevice);
      }
    } else {
      acc.push({
        title: groupTitle,
        description: groupDescription,
        type: device.lob,
        devices: [cardDevice],
      });
    }
    return acc;
  }, []);
};
